import { checkoutOptimizationStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const createCheckoutSplitFromFlowSteps = {
  name: "createCheckoutSplitFromFlowSteps" as const,
  input: z.object({ flowSteps: checkoutOptimizationStepArraySchema }),
  output: z.null(),
};
